import React from 'react';
import Box from '@mui/material/Box';
import { useEdc } from './EdcContext';

const DRIP_COUNT = 28;

export default function EdcMeltOverlay() {
  const { melting } = useEdc();

  const drips = React.useMemo(
    () =>
      Array.from({ length: DRIP_COUNT }, (_, i) => {
        const left = (i / DRIP_COUNT) * 100 + (Math.random() * 2 - 1);
        const width = 100 / DRIP_COUNT + Math.random() * 2;
        const delay = Math.random() * 0.35;
        const duration = 1.6 + Math.random() * 1.4;
        const stretch = 60 + Math.random() * 90;
        const palette = ['#ffd400', '#9b30ff', '#ff2bd6', '#000000', '#ffffff'];
        const color = palette[i % palette.length];
        return { left, width, delay, duration, stretch, color, id: i };
      }),
    [],
  );

  return (
    <Box
      className={`edc-melt-overlay ${melting ? 'is-melting' : ''}`}
      aria-hidden={!melting}
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 99999,
        pointerEvents: melting ? 'auto' : 'none',
        opacity: melting ? 1 : 0,
        transition: 'opacity 0.25s ease',
      }}
    >
      <Box
        className="edc-melt-canvas"
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'radial-gradient(circle at 20% 20%, #9b30ff 0%, transparent 55%),' +
            'radial-gradient(circle at 80% 30%, #ffd400 0%, transparent 50%),' +
            'radial-gradient(circle at 50% 80%, #ff2bd6 0%, transparent 55%),' +
            'linear-gradient(180deg, #050007 0%, #1b0030 60%, #000 100%)',
          mixBlendMode: 'normal',
        }}
      />
      <Box
        className="edc-melt-drips"
        sx={{ position: 'absolute', inset: 0, overflow: 'hidden' }}
      >
        {drips.map((d) => (
          <Box
            key={d.id}
            className="edc-drip"
            sx={{
              position: 'absolute',
              top: 0,
              left: `${d.left}%`,
              width: `${d.width}%`,
              height: `${d.stretch}%`,
              background: `linear-gradient(180deg, ${d.color} 0%, ${d.color} 70%, transparent 100%)`,
              borderBottomLeftRadius: '50% 30%',
              borderBottomRightRadius: '50% 30%',
              transform: 'translateY(-105%)',
              animation: melting
                ? `edc-drip-fall ${d.duration}s cubic-bezier(.55,.05,.2,1) ${d.delay}s forwards`
                : 'none',
              filter: 'drop-shadow(0 0 12px rgba(255,255,255,0.25))',
            }}
          />
        ))}
      </Box>
      <Box
        className="edc-melt-title"
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          letterSpacing: '0.15em',
          fontFamily: '"Staatliches", "Lexend Deca", sans-serif',
        }}
      >
        <Box
          className="edc-melt-layer edc-melt-layer-white"
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
          }}
        >
          <Box
            component="span"
            sx={{
              fontSize: { xs: '4rem', sm: '7rem', md: '10rem' },
              lineHeight: 1,
              fontWeight: 800,
            }}
          >
            EDC
          </Box>
          <Box
            component="span"
            sx={{
              fontSize: { xs: '0.9rem', sm: '1.1rem' },
              mt: 1,
              opacity: 0.85,
              letterSpacing: '0.4em',
            }}
          >
            UNDER THE ELECTRIC SKY
          </Box>
        </Box>

        <Box
          className="edc-melt-layer edc-melt-layer-black"
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#000',
          }}
        >
          <Box
            component="span"
            sx={{
              fontSize: { xs: '4rem', sm: '7rem', md: '10rem' },
              lineHeight: 1,
              fontWeight: 800,
            }}
          >
            EDC
          </Box>
          <Box
            component="span"
            sx={{
              fontSize: { xs: '0.9rem', sm: '1.1rem' },
              mt: 1,
              opacity: 0.85,
              letterSpacing: '0.4em',
            }}
          >
            UNDER THE ELECTRIC SKY
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
